export { default } from './Skeleton.jsx';
